import React, { useEffect } from 'react';
import { observer } from 'mobx-react';
import { useLocation } from 'react-router';
import { getArray } from '../../utils/helpers';
import { languageStore } from '../../subscriber/Language';
import HeroSection from '../../components/HeroSection';
import ExperienceSection from './components/ExperienceSection';
import GallerySection from './components/GallerySection';
import Awards from './components/Awards';
import Philosophy from './components/Philosophy';
import SocialMedia from "../../components/socialMedia";
import NewBeginning from './components/NewBeginning';
import SeoHelmet from '../../components/SeoHelmet';
import BioSection from './components/BioSection';
import staticBlogs from '../../data/blogs.json';
import OurTeam from './components/OurTeam';
import Layout from "../layout";

// Import images
import heroImage from "../../assets/my_story_banner_image.png";
import cooking16 from "../../assets/cooking-16.png";
import cooking17 from "../../assets/cooking-17.png";
import cooking18 from "../../assets/cooking-18.png";
import cooking19 from "../../assets/cooking-19.png";

// const TestimonialsSection = lazy(() => import('../home/components/TestimonialsSection'), {
//     ssr: false,
//     loading: () => <div>Loading testimonials...</div>,
// });

const AboutUs = observer(() => {
    const location = useLocation();
    const { getPageTranslations } = languageStore;
    const t = getPageTranslations('about_us');
    // const social = getPageTranslations('social');
    
    // update the page title using Helmet
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [location.pathname]);

    const getCookingIcon = (index) => {
        const cookingIcons = [cooking16, cooking17, cooking18, cooking19];
        return (
            <img
                src={cookingIcons[index]}
                alt={`Cooking icon ${index + 1}`}
                width={70}
                height={70}
                className="mx-auto mb-4"
            />
        );
    };

    // 👇 SEO meta only from Home
    const seoMyStory = staticBlogs.find(b => b.slug === 'about_us');

    return (
        <Layout>
            <SeoHelmet
                title={seoMyStory.name}
                description={seoMyStory.sort_description}
                image={seoMyStory.path}
                url={seoMyStory.url}
            />
            <div className="bg-[#FFF] min-h-screen">

                {/* Hero Section */}
                <HeroSection
                    backgroundImage={heroImage}
                    title={t?.title}
                />
                <main className="container mx-auto px-4 bg-[#FFF]">
                    <div className="py-24 flex flex-wrap">
                        {/* Sidebar */}
                        <SocialMedia />
                        <div className="w-full md:w-10/12">
                            <article className="prose max-w-none">
                                {/* Main Content */}
                                <BioSection t={t} />

                                {/* Image Gallery Section */}
                                <GallerySection t={t} />

                                {/* Features Section */}
                                <section className="py-12 bg-white">
                                    <div className="container mx-auto px-4 max-w-[1200px]">
                                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
                                            {/* Feature items */}
                                            {getArray(t?.features).map((feature, index) => (
                                                <div key={index} className="text-center">
                                                    {getCookingIcon(index)}
                                                    <h3 className="text-[32px] font-['Libre Caslon Display',sans-serif] font-medium leading-[38.4px] text-[#1F0707] mt-8 mb-4">{feature.title}</h3>
                                                    <p >{feature.description}</p>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </section>
                                <ExperienceSection t={t} />
                                <Philosophy t={t?.philosophy} />
                                <NewBeginning t={t?.beginning} />
                                <Awards t={t} />
                                {/* Specialties Section */}

                            </article>
                        </div>
                    </div>
                </main>
                {/* Team Section */}
                <OurTeam t={t} />
                {/* <SocialSection bgColor={true} t={social} /> */}
                {/* Testimonial Section */}
                {/* <section className="py-24 bg-[#FFF]">
                    <div className="container mx-auto px-4 max-w-[1200px]">
                        <TestimonialsSection />
                    </div>
                </section> */}
            </div>
        </Layout>
    );
});

export default AboutUs;